import { render, staticRenderFns } from "./statisticsCoupon.vue?vue&type=template&id=71329c01&scoped=true"
import script from "./statisticsCoupon.vue?vue&type=script&lang=js"
export * from "./statisticsCoupon.vue?vue&type=script&lang=js"
import style0 from "./statisticsCoupon.vue?vue&type=style&index=0&id=71329c01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71329c01",
  null
  
)

export default component.exports